export default __webpack_public_path__ + "static/media/location-secondary.4dc52a87.svg";